export enum AcknowledgementType {
  TermsOfUse = 'TermsOfUse',
  PrivacyPolicy = 'PrivacyPolicy',
  AiDisclaimer = 'AiDisclaimer',
  ESignature = 'ESignature',
}
